<template>
  <v-row justify="center">
    <v-dialog v-model="openGallery" fullscreen hide-overlay transition="dialog-bottom-transition" @keydown.esc="$emit('closeGallery')">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="$emit('closeGallery')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Select Image</v-toolbar-title>
        </v-toolbar>
        <v-container>
          <v-row v-if="loading === true" class="d-flex justify-center">
            <v-col cols="12" md="12" sm="12" xs="12" class="text-center">
              <h4>Loading Images</h4>
              <v-progress-linear color="primary" indeterminate rounded height="6"></v-progress-linear>
            </v-col>
          </v-row>
          <v-row v-if="loading === false">
            <v-col v-for="(item, idx) in images" :key="idx" class="d-flex child-flex" cols="4">
              <div class="imgDiv">
                <v-checkbox class="ma-0 selectedCheckbox" v-model="selectedImages" :value="item" dense />
                <v-img max-height="150" max-width="200" :src="`${item.url}`" aspect-ratio="1"></v-img>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
      <v-footer fixed>
        <v-col class="text-right">
          <v-btn color="primary" class="mr-2" @click="done" small>Upload</v-btn>
        </v-col>
      </v-footer>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  watch: {
    isOpen (val) {
      this.openGallery = val
    }
  },
  props: ['isOpen'],
  computed: {
    columns () {
      const columns = []
      const divide = 3
      const mid = Math.ceil(this.images.length / divide)
      for (let col = 0; col < divide; col++) {
        columns.push(this.images.slice(col * mid, col * mid + mid))
      }
      return columns
    }
  },
  created () {
    this.$axios.post('getImageList', {}).then((res) => {
      this.images = res.data.image_data
      this.loading = false
    }).catch((err) => {
      this.loading = false
      console.log('err')
      console.log(err)
    })
  },
  data () {
    return {
      loading: true,
      images: [],
      selectedImages: [],
      openGallery: this.isOpen
    }
  },
  methods: {
    done () {
      this.$emit('closeGallery')
      this.$emit('selectedImage', this.selectedImages)
    }
  }
}
</script>
<style>
.imgDiv {
  position: relative;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 15px 0 rgba(0, 0, 0, 0.19);
}
.selectedCheckbox {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1000;
}
</style>
